import localStorageAvailable from '../../utils/localStorageAvailable';
import axios from '../../utils/axios';

const postUploadImage = async (user, data,url) => {
    const storageAvailable = localStorageAvailable();
    const accessToken = storageAvailable ? localStorage.getItem('accessToken') : '';

    const config = {
        method: 'post',
        maxBodyLength: Infinity,
        url,
        headers: {
            authorization: `Bearer ${accessToken}`,
            user,
        },
        data,
    };
    const response = await axios.request(config);
    return response.data;
};

export default postUploadImage;
